import React, { Component } from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import Icon from 'components/icon';
import FormField from 'components/form/form-field';
import classnames from 'classnames';
import { t } from 'translations';

function Label({ id, text }) {
    return (
        <label className="form-field--title-label" htmlFor={id}>
            {text}
        </label>
    );
}

Label.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

function FloatingLabel({ text }) {
    return (
        <span className="form-field--floating-label" aria-hidden="true">
            {text}
        </span>
    );
}

FloatingLabel.propTypes = {
    text: PropTypes.string.isRequired,
};

function Action({ symbol, size, type, action, label }) {
    return (
        <div className="form-field--actions">
            <button onClick={action} type="button" className={`form-field--action form-field--action__${ type }`}
                aria-label={label}>
                <Icon symbol={symbol} size={size}/>
            </button>
        </div>
    );
}

Action.propTypes = {
    symbol: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    action: PropTypes.func,
    label: PropTypes.string,
};

Action.defaultProps = {
    symbol: PropTypes.string.isRequired,
    size: 'medium',
    action: noop,
};

/**
 * We will compose the following markup using many props coming from the parent component
 * @returns {XML}
 * @constructor
 */
class TextInput extends Component {
    componentWillUpdate(nextProps) {
        const { hasFocus, setStateClasses } = this.props;
        if (nextProps.hasFocus !== hasFocus) {
            setStateClasses({ 'form-field__has-focus': nextProps.hasFocus });
        }
    }

    onClearAction = () => {
        if (typeof this.props.hasClearAction === 'function') {
            this.props.hasClearAction();
        }
        this.props.updateValue('');
    };

    render() {
        const {
            label,
            id,
            value,
            state,
            type,
            onFocus,
            onKeyPress,
            onBlur,
            updateValue,
            placeholder,
            hasFloatingLabel,
            actionCount,
            icon,
            action,
            variant,
            hasClearAction,
            autoFocus,
            actionLabel,
            pattern,
            autoComplete,
        } = this.props;

        return [
            label ? <Label key="label" id={id} text={label}/> : null,
            <div key="content" className="form-field--input-container" data-action-count={actionCount}>
                {hasFloatingLabel && label ? <FloatingLabel text={label}/> : ''}
                <input
                    {...{
                        'aria-label': this.props['aria-label'],
                    }}
                    autoComplete={autoComplete}
                    className={classnames('form-field--input', this.props.className)}
                    type={type}
                    placeholder={placeholder}
                    id={id}
                    name={id}
                    required={state.required}
                    disabled={state.disabled}
                    value={value}
                    pattern={pattern}
                    onChange={e => updateValue(e.target.value)}
                    autoFocus={autoFocus}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onKeyPress={onKeyPress}
                />
                {hasClearAction && value ?
                    <Action symbol="cancel_input" type="clear" size="large" action={() => this.onClearAction()}
                        label={t('form.field_clear')}/> : null}
                {!value && icon ?
                    <Action symbol={icon.symbol} type={type} variant={variant} size={icon.size} action={action}
                        label={actionLabel}/> : ''}
            </div>,
        ];
    }
}

TextInput.propTypes = {
    hasFloatingLabel: PropTypes.bool,
    hasFocus: PropTypes.bool,
    setStateClasses: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func,
    actionCount: PropTypes.number.isRequired,
    action: PropTypes.func,
    icon: PropTypes.object,
    onFocus: PropTypes.func.isRequired,
    updateValue: PropTypes.func.isRequired,
    variant: PropTypes.string,
    hasClearAction: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    type: PropTypes.string.isRequired,
    id: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    state: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    messages: PropTypes.object,
    className: PropTypes.string,
    autoFocus: PropTypes.bool,
    actionLabel: PropTypes.string,
    pattern: PropTypes.string,
    formClasses: PropTypes.object,
    'aria-label': PropTypes.string,
    autoComplete: PropTypes.string,
    disabled: PropTypes.bool,
};

TextInput.defaultProps = {
    hasClearAction: true,
    autoFocus: false,
    disabled: false,
    autoComplete: 'on',
};

export default function FormFieldInput(props) {
    return <FormField {...props} facet="input" component={TextInput}/>;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/form/form-field-input/index.js